<template>
	<div class="gtm-dashboard">
		<report-section
			v-for="section in sections"
			:key="section.uuid"
			:section="section"
			:hospital-id="hospitalId"
			:listing-id="listingId"
			:organisation-id="organisationId"
		></report-section>
	</div>
</template>

<script>
import ReportSection from "./ReportSection";
import { mapGetters } from "vuex";

export default {
	name: "VuexLayoutsPage",
	components: {
		ReportSection
	},
	props: {
		page: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		...mapGetters({
			hospitalId: "reportQueries/hospitalID",
			listingId: "reportQueries/listingID",
			organisationId: "reportQueries/organisationID"
		}),
		sections() {
			return this.layout;
		},
		layout() {
			return JSON.parse(this.page.layout);
		}
	},
	methods: {
		issplit(row) {
			if (row.length >= 1) {
				const { type } = row[0];
				return type === "split" ? "page-break" : null;
			}
		}
	}
};
</script>
